// extracted by mini-css-extract-plugin
export var fileUpload = "_gh-1";
export var modalButton = "_gh-0";